import { jwtDecode } from "jwt-decode"; // ✅ Correct for TS

interface JwtPayload {
  AllowedScreens?: string | string[];
  allowedscreens?: string | string[];
  [key: string]: unknown;
  exp?: number; 
}

export function getAllowedTabsFromToken(token?: string | null): string[] {
  if (!token) {
    token = JSON.parse(localStorage.getItem("Dinelyt_session") || '{}')?.token || '';
  }

  if (!token) return [];

  try {
    const decoded = jwtDecode<JwtPayload>(token); // ✅ works with TS
    const allowedScreens = decoded.AllowedScreens || decoded.allowedscreens || "";

    if (typeof allowedScreens === "string" && allowedScreens.trim()) {
      return allowedScreens.split(",").map(s => s.trim());
    }

    if (Array.isArray(allowedScreens)) {
      return allowedScreens.map(s => String(s).trim());
    }

    return [];
  } catch (error) {
    console.error("Invalid token while reading AllowedTabs:", error);
    return [];
  }
}


export function isValidToken(token?: string | null): boolean {
  if (!token) {
    token = JSON.parse(localStorage.getItem("Dinelyt_session") || '{}')?.token || '';
  }

  if (!token) return false;

  try {
    const decoded = jwtDecode<JwtPayload>(token);

    if (!decoded.exp) return false; // No expiry means invalid

    const nowInSeconds = Math.floor(Date.now() / 1000);
    return decoded.exp > nowInSeconds;
  } catch (error) {
    console.error("Invalid token while validating:", error);
    return false;
  }
}